import axios from 'lib/axios'

const getSkillsReport = async (userTestId: number) => {
  const PATH = `/follow-up/measurement/${userTestId}/pdf`
  try {
    const response = await axios.post(PATH, {}, { responseType: 'blob' })
    return { url: URL.createObjectURL(response.data) }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export default getSkillsReport
